<!--
  * @Author: changyunxia
  * @Date:2020年10月12日 13:04:25
  * @LastEditors: changyunxia
  * @LastEditTime: @Date:2020年10月12日 13:04:25
  * @Description: 会议室预定头部
  * @FilePath:@/components/HelloWorld.vue
-->
<template>
  <div>

    <van-nav-bar :title="title" left-arrow :fixed="true">
      <template #left>
        <van-icon name="down" size="18" class="aa" color="#000000" @click="back()" />
      </template>
      <template#right v-if="rightShow">
        <div>
          <span class="font-color pda" @click="onClickmy">我的会议</span>
          <span class="font-color" @click="onClickRight">{{ meetingShow ? '月度': '当日' }}</span>
        </div>
      </template#right>
    </van-nav-bar>
    <div class="height" />
    <!-- <span class="font-color" @click="onClickRight">筛选</span> -->

  </div>
</template>

<script>
export default {
  name: 'MeetingHeader',
  components: {},
  props: {
    title: {
      type: String,
      default: null
    },
    rightShow: {
      type: Boolean,
      default: null
    }

  },
  data() {
    return {
      rightText: '月度',
      // title: '会议室详情',
      //  true  文字显示当日  false 文字显示月度
      meetingShow: false,
      showPopover: false
    }
  },
  computed: {},
  watch: {},
  created() {

  },
  mounted() {
    this.onClickRight()
  },
  methods: {
    onSelect(action) {
      this.$toast(action.text)
    },
    onClickmy() {
      this.$router.push(
        { path: '/index/myMeeting' }
      )
    },
    // 返回上一步
    back() {
      this.$router.go(-1)
    },
    //   月度和当日切换
    onClickRight() {
      this.meetingShow = !this.meetingShow
      this.$emit('previewSwitch', this.meetingShow)
    }
  }
}
</script>
<style lang='scss' scoped>

.pda{
  margin-right: 10px;
}
//@import url(); 引入公共css类    transform: rotate(90deg);
.height{
  height:48px;
  width: 100%;
}
.font-color{
    color: cornflowerblue;
}
.aa{
     transform: rotate(90deg);
}
/deep/ .van-nav-bar--fixed{
  z-index: 999;
}
.pda{
  padding-left: 10px;
}
</style>
